import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './bottom-nav.component.html',
  styleUrl: './bottom-nav.component.scss'
})
export class BottomNavComponent {

   @Input() nextHidden = false;
  @Input() nextDisabled = false;
  @Input() nextCaption = 'Weiter';

  @Input() cancelHidden = false;
  @Input() cancelDisabled = false;
  @Input() cancelCaption = 'Abbrechen';

  @Input() backHidden = false;
  @Input() backDisabled = false;
  @Input() backCaption = 'Zurück';
  @Input() backRoute: string | any[] = '';
  @Input() alignNotReq = false;

  @Output() nextClicked = new EventEmitter<void>();

  @Output() backClicked = new EventEmitter<void>();

  @Output() cancelClicked = new EventEmitter<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  onNext() {
    this.nextClicked.emit();
  }

  onBack() {
    this.backClicked.emit();
    const backRoute =
      typeof this.backRoute === 'string'
        ? ['..', this.backRoute]
        : this.backRoute;
    if (!this.backDisabled && this.backRoute.length > 0) {
      this.router.navigate(backRoute, { relativeTo: this.activatedRoute });
    }
  }

  onCancel() {
    this.cancelClicked.next();
  }

  isRegistration() {
    return window.location.href.includes('registration');
  }

  // isIdentification() {
  //   return window.location.href.includes('identification');
  // }
}
